import { spore } from '@/spore/runtime';
import { Panel } from './Panel';

const TILES = [
  { type: 'PULSE', id: 'pulse', color: '#ff4d4d', desc: 'any spike (incl. ethereal)' },
  { type: 'SOLID', id: 'solid', color: '#ff8a3d', desc: 'confident pulse · counts for unlocks' },
  { type: 'STROKE', id: 'stroke', color: '#ffb000', desc: 'gentle sustained input' },
  { type: 'STILL', id: 'still', color: '#00e5ff', desc: 'stillness threshold' },
];

const Tile = ({ tile, count, last }) => (
  <div
    key={last ? last.n : 0}
    data-testid={`gesture-indicator-${tile.id}`}
    data-count={count}
    className={`gesture-tile flex items-center justify-between px-4 py-3 ${last ? 'flash' : ''}`}
    style={{ '--flash-color': `${tile.color}66` }}
  >
    <div>
      <div className="font-display text-xl font-bold tracking-[0.18em]" style={{ color: tile.color }}>{tile.type}</div>
      <div className="text-xs text-[var(--muted)]">
        {tile.desc}
        {last && last.seconds ? ` · last ${last.seconds}s` : ''}
        {last && last.confidence !== undefined ? ` · conf ${last.confidence}` : ''}
      </div>
    </div>
    <span data-testid={`gesture-count-${tile.id}`} className="font-display text-4xl font-extrabold tabular-nums" style={{ color: tile.color }}>{count}</span>
  </div>
);

export const Gestures = ({ counts, lastGesture, gestures }) => (
  <Panel
    testId="gestures-panel"
    code="04 / GESTURES"
    title="Gesture Detector"
    delay={200}
    right={<button data-testid="gesture-reset-counts-button" className="btn-lab px-3 py-1 text-[0.65rem]" onClick={() => spore.resetCounts()}>Reset</button>}
  >
    <div className="space-y-3">
      {TILES.map((t) => (
        <Tile key={t.type} tile={t} count={counts[t.type]} last={lastGesture[t.type]} />
      ))}
    </div>
    <div className="mt-4 label-eyebrow">Recent</div>
    <div data-testid="gesture-recent-list" className="mt-1 flex flex-wrap gap-1 text-[0.7rem]">
      {gestures.slice(0, 14).map((g, i) => (
        <span key={`${g.t}-${i}`} className="border border-[var(--hair)] px-1.5" style={{ color: (TILES.find((x) => x.type === g.type) || { color: '#7d8a91' }).color }}>
          {g.type}{g.seconds ? g.seconds : ''}{g.type === 'PULSE' ? (g.solid ? '·S' : '·e') : ''}
        </span>
      ))}
    </div>
  </Panel>
);
